import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["fill"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
export function HeadphoneAltIcon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1C1C33' : _ref$fill,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, restProps), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75387 9.26086C4.88004 5.36735 8.07581 2.25 12 2.25C15.9242 2.25 19.12 5.36735 19.2461 9.26086C20.65 9.38527 21.75 10.5637 21.75 12V15C21.75 16.5192 20.5192 17.75 19 17.75H18.75V18C18.75 19.5192 17.5192 20.75 16 20.75H14.4795C14.1827 21.4828 13.464 22 12.625 22H11.375C10.2708 22 9.375 21.1042 9.375 20C9.375 18.8958 10.2708 18 11.375 18H12.625C13.464 18 14.1827 18.5172 14.4795 19.25H16C16.6908 19.25 17.25 18.6908 17.25 18V17.5815C16.6589 17.3005 16.25 16.6978 16.25 16V11C16.25 10.1203 16.8998 9.39174 17.7454 9.2684C17.6239 6.2 15.0982 3.75 12 3.75C8.90178 3.75 6.37611 6.2 6.25458 9.2684C7.10021 9.39174 7.75 10.1203 7.75 11V16C7.75 16.9662 6.96621 17.75 6 17.75H5C3.48079 17.75 2.25 16.5192 2.25 15V12C2.25 10.5637 3.35004 9.38527 4.75387 9.26086ZM5.5 10.75H5C4.30921 10.75 3.75 11.3092 3.75 12V15C3.75 15.6908 4.30921 16.25 5 16.25H6C6.13779 16.25 6.25 16.1378 6.25 16V11C6.25 10.8622 6.13779 10.75 6 10.75H5.5ZM18.5 10.75H18C17.8622 10.75 17.75 10.8622 17.75 11V16C17.75 16.1378 17.8622 16.25 18 16.25H19C19.6908 16.25 20.25 15.6908 20.25 15V12C20.25 11.3092 19.6908 10.75 19 10.75H18.5ZM11.375 19.5C11.0992 19.5 10.875 19.7242 10.875 20C10.875 20.2758 11.0992 20.5 11.375 20.5H12.625C12.9008 20.5 13.125 20.2758 13.125 20C13.125 19.7242 12.9008 19.5 12.625 19.5H11.375Z",
      fill: fill
    })
  }));
}